import { render, staticRenderFns } from "./WorkSection.vue?vue&type=template&id=514bd75f&"
import script from "./WorkSection.vue?vue&type=script&lang=js&"
export * from "./WorkSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports